export function initServiceCheckInLogin() {
    const toggles = document.querySelectorAll('.cms-content-slice__service-check-in-login [data-password-toggle]');

    if (!toggles.length) {
        return;
    }

    toggles.forEach((toggle) => {
        const input = document.getElementById(toggle.dataset.passwordToggle);
        const icon = toggle.querySelector('img');

        if (!input) {
            return;
        }

        toggle.addEventListener('click', () => {
            const isPassword = input.getAttribute('type') === 'password';

            input.setAttribute('type', isPassword ? 'text' : 'password');

            if (icon) {
                icon.src = isPassword
                    ? '/images/my-account/eye-closed.svg'
                    : '/images/my-account/eye-open.svg';
            }
        });
    });
}
